<template>
    <div class="address">
        <div v-if="showEmpty" style="margin-top:50px">
            <van-empty img="https://static.beautyfarm.com.cn/vip_admin/icon/empty12.png" description="您还未添加收货地址，请添加" />
        </div>
        <div class="addresslist">
            <div class="addressitem flex-col WhiteBg" v-for="item, index in addressList" :key="index">
                <div class="top" @click="selectAddress(item)">
                    <div class="Black font28">
                        <span>{{ item.addressDTO.name }}</span>
                        <span class="padding-left">{{ item.addressDTO.phone }}</span>
                    </div>
                    <div class="Grey font28 padding-top-xs lineheight40">
                        {{ item.addressDTO.province + (item.addressDTO.province == item.addressDTO.city ? '' :
                            item.addressDTO.city) + item.addressDTO.district + item.addressDTO.street
                        }}
                    </div>
                </div>
                <div class="bottom flex-row flex-between">
                    <div class="flex-row flex-y-center">
                        <van-checkbox v-model="item.isSelected" checked-color="#333F48" shape="square" @click="checkboxClick(item)"></van-checkbox>
                        <span class="font28 Grey padding-left-xs">设为默认地址</span>
                    </div>
                    <div class="flex-row">
                        <div class="flex-row flex-y-center Grey font28" @click="toEdit('edit', item.id, item.address, item.isDefault)">
                            <van-icon name="edit" color="#999999" size="20px" />
                            <span class="padding-left-sm">编辑</span>
                        </div>
                        <div class="flex-row flex-y-center Grey font28 padding-left" @click="delAddress(index)">
                            <van-icon name="delete" color="#999999" size="20px" />
                            <span class="padding-left-sm">删除</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fixed flex-row flex-between flex-y-center">
            <button class="add" @click="toEdit('add')">新增地址</button>
        </div>
    </div>
</template>
<script>

    import request from "@/utils/request";
    import { Toast, Dialog } from 'vant'

    export default {
        name: "myAddressJm",
        data() {
            return {
                addressList: [],
                checked: true,
                showEmpty: false,
                fromPath: '',
                address: '',
                addressid: '',
                isDefault: '',
            };
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                // 通过 `vm` 访问组件实例,将值传入fromPath
                vm.fromPath = from.path
            })
        },
        created() {
            this.$nextTick(() => {
                this.recAddressList();
            })
        },
        methods: {
            // 获取收货地址列表
            recAddressList() {
                request({
                    url: "/jm/address/recAddressList",
                    method: "get",
                })
                    .then((res) => {
                        res.data.forEach(item => {
                            item.isSelected = item.isDefault === 1
                        })
                        this.addressList = res.data
                        this.showEmpty = res.data.length == 0 ? true : false
                    }).catch(() => {
                        Toast({ position: 'top', message: error ?? '' })
                    })

            },
            // 设为默认地址
            checkboxClick(item) {
                let param = {
                    id: item.id,
                    address: item.address,
                    isDefault: item.isSelected ? 1 : 0,
                };
                request({
                    url: `/jm/address/editRecAddress`,
                    method: "post",
                    data: param
                })
                    .then(() => {
                        this.recAddressList();
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },

            // 选择列表
            selectAddress(item) {
              console.log(item,'itemitemitem')
                this.$store.commit('order/SET_ADDRESS_DETAIL', { id: item.id, ...item.addressDTO })
                this.$router.go(-1)
            },
            // 新增/编辑地址
            toEdit(type, id, address, isDefault) {
                this.$router.push({ name: "addressEditJm", query: { type: type, id: id, address: address, isDefault: isDefault } });

            },
            // 删除地址
            delAddress(index) {
                let addressList = this.addressList;
                Dialog.confirm({
                    title: '温馨提示',
                    message: '确定要删除此收货地址吗？',
                    confirmButtonColor: '#3fb8e2'
                })
                    .then(() => {
                        request({
                            url: "/jm/address/deleteRecAddress?id=" + addressList[index].id,
                            method: "get",
                        })
                            .then(() => {
                                this.recAddressList();
                            }).catch((error) => {
                                Toast({ position: 'top', message: error ?? '' })
                            })
                    })
                    .catch(() => {
                    })
            },

        },
    };
</script>
<style lang="less" scoped>
    .address {
        height: 100%;
        overflow-y: auto;
        background: #f5f6f5;
    }

    .padding-top-xs {
        padding-top: 20px;
    }

    /* 图标 */
    .van-checkbox__icon {
        font-size: 32px !important;
    }

    .lineheight40 {
        line-height: 40px;
    }

    .addresslist {
        padding: 30px 30px 220px 30px;
    }

    .addresslist .addressitem {
        width: 100%;
        border-radius: 12px;
        padding: 30px;
        margin-bottom: 20px;
    }

    .addressitem .top {
        padding-bottom: 25px;
        border-bottom: 2px solid rgba(215, 215, 215, 0.39);
    }

    :deep(.van-checkbox) {
        margin-bottom: 0 !important;
    }

    .addressitem .bottom {
        padding-top: 30px;
    }

    /* 底部按钮 */
    .fixed {
        width: 100%;
        height: 180px;
        position: fixed;
        padding: 0 30px;
        bottom: 100px;
        z-index: 20;
    }

    .fixed .add {
        width: 630px;
        height: 88px;
        border-radius: 50px;
        line-height: 55px;
        text-align: center;
        font-size: 32px;
        color: #ffffff;
        background: #333f48;
        font-weight: normal;
        margin: 0 auto;
    }

    /* 空状态 */
    .van-empty {
        padding-top: 200px !important;
    }
</style>